import React from 'react'
//import Navbar from '../components/landingPage/header/Navbar'
import Footer from '../components/landingPage/footer/Footer'
import { Outlet } from 'react-router-dom'

//Landing pages layout It Will render pages with header and footer

const LandingPageHF = () => {
  return (
    <>
      {/*    <Navbar /> */}
      <div className="min-h-[calc(100vh_-_60vh)]">
        <Outlet />
      </div>
      <Footer />
    </>
  )
}

export default LandingPageHF
